<template>
    <div class="container-fluid">
        <div class="row">
            <FormRepairRequest @update:modelValue="handleFormUpdate"/>
        </div>
        <div class="col-12 d-flex justify-content-end gap-2 pt-3">
            <button class="btn btn-outline-success" type="button" @click="console.log(formData)">
                <i class="bi bi-x-circle"></i> บันทึก
            </button>
        </div>
    </div>
</template>

<script setup>
import { ref, defineAsyncComponent } from 'vue'
import Swal from 'sweetalert2'

const formData = ref({});

const handleFormUpdate = (updatedData) => {
    formData.value = updatedData;
    console.log('Form data updated:', formData.value);
};

const FormRepairRequest = defineAsyncComponent(() => import("@/components/theme/repair-request/FormRepairRequest.vue"))
</script>